import ProfileAppointments from './profile-appointments.vue'
export default ProfileAppointments